<template>
  <div>
    <el-row>
      <h2>盘库审核</h2>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="ENTRY_DATE" label="日期" min-width="100"></el-table-column>
          <el-table-column prop="PK_CODE" label="盘库编号" min-width="160"></el-table-column>
          <el-table-column prop="AFTER_WORTH" label="盘库金额" min-width="80"></el-table-column>
          <el-table-column label="盘赢/盘亏" min-width="90">
            <template slot-scope="scope">
              <span :style="{color:scope.row.PK_VALUE >=0 ? '#67C23A' : '#F56C6C'}">
                {{scope.row.PK_VALUE}}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="状态" min-width="100">
            <template slot-scope="scope">
              <el-tag v-text="status[scope.row.STATUS][0]" :type="status[scope.row.STATUS][1]"></el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-view" size="small" @click="detail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="total_count" style="float: right">
      </el-pagination>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';


export default {
  data() {
    return {
      tableData: [],
      total_count: 0,
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      status: { 101: ['未审核', 'warning'], 202: ['已拒绝', 'danger'] },
    };
  },
  created() {
    this.queryData();
  },
  methods: {
    queryData() {
      const params = {
        SERVICE_ID: '10030',
        OTYPE: 15,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      http.post(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result[0].list;
            this.total_count = result[0].TOTAL_COUNT;
          } else {
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    detail(row) {
      this.$router.push({ path: `/stockCheckAuditDetail/${row.ID}/${row.PK_CODE}/${row.STATUS}`, params: { id: row.ID, pkc: row.PK_CODE, status: row.STATUS } });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/audit/stockCheckAudit.vue